// next
// @mui
import { styled } from '@mui/material/styles';
import { Box, Card, Stack, Container, Typography, useTheme } from '@mui/material';
// routes
// hooks
import useResponsive from '../../hooks/useResponsive';
// guards
import GuestGuard from '../../guards/GuestGuard';
// components
import Page from '../../components/Page';
import Image from '../../components/Image';
// sections
import { LoginForm } from '../../sections/auth/login';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const mdUp = useResponsive('up', 'md');
  const theme = useTheme();

  return (
    <GuestGuard>
      <Page title="Login">
        <RootStyle>
          {mdUp && (
            <SectionStyle>
              <Box sx={{ mb: 7 }}>
                <Stack direction="row" sx={{ px: 5, mt: 10, mb: 6 }}>
                  <Image
                    disabledEffect
                    visibleByDefault
                    alt="logo"
                    src="/logo/coteam_text_logo.png"
                    sx={{ maxWidth: 240, maxHeight: 32, pb: 0.2 }}
                  />
                  <Typography variant="h4" sx={{ pl: 1 }}>
                    へようこそ
                  </Typography>
                </Stack>
                <Image src="/images/top_illustration.png" alt="login" />
              </Box>
            </SectionStyle>
          )}
          <Container maxWidth="sm">
            <ContentStyle>
              <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h4" gutterBottom>
                    ログイン
                  </Typography>
                  <Typography sx={{ color: theme.palette.text.secondary }}>
                    メールアドレスとパスワードを入力してください。
                  </Typography>
                </Box>
              </Stack>
              <LoginForm />
            </ContentStyle>
          </Container>
        </RootStyle>
      </Page>
    </GuestGuard>
  );
}
